<template>
    <VideoPlayer class="embed-file-video-transcoded" v-if="file" :sources="sources" :poster="overridePoster ?? file.poster"></VideoPlayer>
</template>

<script>

export default {
    name: 'EmbedFileVideoTranscoded',
    props: ['file', 'overridePoster'],
    computed: {
        sources () {
            const sources = [];
            if (!this.file) return null;
            // Prefer transcoded webm
            // if (this.file.webm) {
            //     sources.push({
            //         src: this.file.webm,
            //         type: 'video/webm; codecs="vp8, vorbis"'
            //     });
            // }
            // Use transcoded mp4 if webm is not supported by browser
            if (this.file.mp4) {
                sources.push({
                    src: this.file.mp4,
                    type: 'video/mp4'
                });
            }
            // Fallback to the originally uploaded file if transcoded file is missing / corrupt / unsupported
            if (this.file.url) {
                sources.push({
                    src: this.file.url
                });
            }
            return sources;
        },
    },
};
</script>
